/**
 * @namespace ExternalLink
 * @aka COMMON.ExternalLink
 *
 * @see https://floating-ui.com/docs/getting-started
 */
COMMON.ExternalLink = function ($, FloatingUIDOM) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'external-link';
  var DATA_KEY = 'common.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY,
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };
  var Selector = {
    DATA_TOGGLE: 'a[rel*=external]'
  };

  var whitelist = {
    hostname: [
      'www.swr.de',
      'www.swr3.de',
      'www.dasding.de',
      'www.newszone.de',
      'www.planet-schule.de',
      'www.kindernetz.de',
      'www.tagesschau.de',
      'www.sportschau.de',
      'www.ard.de',
      'www.ard-digital.de',
      'www.daserste.de',
      'www.kika.de',
      'ard.social',
      '1.ard.de',
      'www.ardaudiothek.de',
      'www.ardmediathek.de',
      'wahl.swr.de'
    ],
    protocol: [
      'mailto:',
      'tel:'
    ]
  };

  var forwardingPages = [
    '/assets/kindernetz/byebye.html'
  ];

  var $body = $('body');

  var portalString = COMMON.Utils.getPortal();

  var _render = function _render() {
    var textLabel = 'Der Link &ouml;ffnet eine Internetseite au&szlig;erhalb ' + portalString[6].toLowerCase() + portalString[1] + '/der <abbr title="Arbeitsgemeinschaft der öffentlich-rechtlichen Rundfunkanstalten der Bundesrepublik Deutschland">ARD</abbr>.';
    var textParagraph = portalString[0] + portalString[1] + '/Die <abbr title="Arbeitsgemeinschaft der öffentlich-rechtlichen Rundfunkanstalten der Bundesrepublik Deutschland">ARD</abbr> ist für den Inhalt externer Internetseiten nicht verantwortlich. Es kann sich dabei auch um ein Bezahlangebot handeln.';

    if(portalString[1] === "Kindernetz"){
      textParagraph = portalString[0] + portalString[1] + '/Die <abbr title="Arbeitsgemeinschaft der öffentlich-rechtlichen Rundfunkanstalten der Bundesrepublik Deutschland">ARD</abbr> ist für den Inhalt externer Internetseiten nicht verantwortlich.';
    }

    var $backdrop = $('<div class="external-link-backdrop" data-spy="dismiss" tabindex="-1"></div>');
    var $dialog = $('<div class="external-link-dialog" aria-modal="true" role="dialog" aria-labelledby="external-link-dialog-label" tabindex="-1">' +
      '<h4 id="external-link-dialog-label">' + textLabel + '</h4>' +
      '<p>' + textParagraph + '</p>' +
      '<div class="btn-group">' +
      '<button class="btn btn-primary" role="button" aria-label="Dem externen Link folgen" data-spy="permit">Website öffnen</button> ' +
      '<button class="btn btn-secondary" role="button" data-spy="dismiss">Abbrechen</button>' +
      '</div>' +
      '<div class="external-link-dialog-arrow"></div>' +
      '</div>');

    $body.append($backdrop);
    $body.append($dialog);
  };

  var referenceEl, floatingEl;

  /**
   * This function will get called repeatedly.
   *
   * @see https://floating-ui.com/docs/autoUpdate
   */
  var updateElementPosition = function updateElementPosition() {
    var arrowEl = floatingEl.querySelector('.external-link-dialog-arrow');

    FloatingUIDOM.computePosition(referenceEl, floatingEl, {
      placement: 'bottom',
      middleware: [
        FloatingUIDOM.offset(6),
        FloatingUIDOM.flip(),
        FloatingUIDOM.shift({
          padding: 8
        }),
        FloatingUIDOM.arrow({
          element: arrowEl
        })
      ]
    }).then(function (_value) {
      floatingEl.style.left = _value.x + 'px'
      floatingEl.style.top = _value.y + 'px'

      var staticSide = {
        top: 'bottom',
        right: 'left',
        bottom: 'top',
        left: 'right'
      }[_value.placement.split('-')[0]];

      arrowEl.style.left = _value.middlewareData.arrow.x != null ? _value.middlewareData.arrow.x + 'px' : '';
      arrowEl.style.top = _value.middlewareData.arrow.y != null ? _value.middlewareData.arrow.y + 'px' : '';
      arrowEl.style.right = '';
      arrowEl.style.bottom = '';
      arrowEl.style[staticSide] = '-4px';
    });
  }

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var ExternalLink = function () {

    function ExternalLink(element) {
      COMMON.Utils._classCallCheck(this, ExternalLink);

      var self = this;

      /**
       * @protected
       */
      self.element = element;
    }

    ExternalLink.prototype.show = function show() {
      var self = this;

      var linkHrefURL = new URL(self.element.href, window.location.origin);

      // Render HTML
      _render();

      referenceEl = self.element
      floatingEl = document.querySelector('.external-link-dialog');

      // Show Tooltip
      updateElementPosition(referenceEl, floatingEl);

      /**
       * cleanup() - Later, when the element is removed from the screen
       *
       * @see https://floating-ui.com/docs/autoUpdate#options
       */
      self.cleanup = FloatingUIDOM.autoUpdate(referenceEl, floatingEl, updateElementPosition, {
        ancestorScroll: true,
        ancestorResize: true,
        elementResize: true,
        layoutShift: true,
        animationFrame: false
      });

      $(document).on('click' + EVENT_KEY + DATA_API_KEY, '[data-spy=permit]', function (event) {
        window.open(linkHrefURL.toString());
        self.element.focus();
        self._hide();
      });

      $(document).on('click' + EVENT_KEY + DATA_API_KEY, '[data-spy=dismiss]', function (event) {
        self._hide();
        self.element.focus();
      });

      $(document).one('pjax:beforeReplace' + EVENT_KEY + DATA_API_KEY, function () {
        self._hide();
      });
    }

    ExternalLink.prototype._hide = function _hide() {
      var self = this;

      $(document).off('click' + EVENT_KEY + DATA_API_KEY, '[data-spy=permit]');
      $(document).off('click' + EVENT_KEY + DATA_API_KEY, '[data-spy=dismiss]');

      $('.external-link-dialog').remove();
      $('.external-link-backdrop').remove();

      referenceEl = null;
      floatingEl = null;

      if (self.cleanup) {
        self.cleanup();
        self.cleanup = null;
      }
    }

    // public
    ExternalLink.prototype.dispose = function dispose() {
      this._hide();

      $(this.element).off(EVENT_KEY);
      $.removeData(this.element, DATA_KEY);

      this.$element = null;
      this.element = null;
    };

    /**
     * @static
     */
    ExternalLink._jQueryInterface = function _jQueryInterface(action) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        if (!data) {
          data = new ExternalLink(this);
          $(this).data(DATA_KEY, data);
        }
        if (typeof action === "string") {
          if (data[action] === undefined) {
            throw new Error('No method named "' + action + '"');
          }
          data[action]();
        }
      });
    };

    return ExternalLink;
  }();


  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
    var element = this;
    var linkHrefURL = new URL(element.href, window.location.origin);
    console.log(linkHrefURL.hostname, linkHrefURL.protocol, linkHrefURL.pathname);
    console.log(whitelist.hostname.indexOf(linkHrefURL.hostname), whitelist.protocol.indexOf(linkHrefURL.protocol), forwardingPages.indexOf(linkHrefURL.pathname));
    if (-1 !== whitelist.hostname.indexOf(linkHrefURL.hostname) || -1 !== whitelist.protocol.indexOf(linkHrefURL.protocol)) {
      if(-1 === forwardingPages.indexOf(linkHrefURL.pathname)){
        //Der Link zeigt nicht auf eine Weiterleitungsseite
        return;
      }
    }

    event.preventDefault();
    event.stopPropagation();

    ExternalLink._jQueryInterface.call($(this), 'show');

    return false;
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = ExternalLink._jQueryInterface;
  $.fn[NAME].Constructor = ExternalLink;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return ExternalLink._jQueryInterface;
  };

  return ExternalLink;

}(window.jQuery, window.FloatingUIDOM);
